<template>
  <div class="block yfhw-page16 f-r f-c">
    <PageHeader
      :title="moduleData['3_23_1_1']"
      :sub-title="moduleData['3_23_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>

    <div class="content-container">
      <div class="head-container">
        <div class="left-container">
          <div class="combo-container">
            <div class="chart-container">
              <div class="title">性别比例</div>
              <VChart
                style="width: 100%; height: 100%"
                :option="pieGenderOption"
              ></VChart>
            </div>
            <div class="info-container">
              <div class="info male">
                <div class="sign">男性</div>
                <div class="percentage">{{ maleValue }}%</div>
              </div>
              <div class="info female">
                <div class="sign">女性</div>
                <div class="percentage">{{ femaleValue }}%</div>
              </div>
            </div>
          </div>

          <div class="combo-container">
            <div class="chart-container">
              <div class="title">未成年子女情况</div>
              <VChart
                style="width: 100%; height: 100%"
                :option="pieChildOption"
              ></VChart>
            </div>
            <div class="info-container">
              <div class="info child">
                <div class="sign">有</div>
                <div class="percentage">{{ hasChildValue }}%</div>
              </div>
              <div class="info no-child">
                <div class="sign">无</div>
                <div class="percentage">{{ noChildValue }}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-container">
          <div class="chart-block">
            <div class="title">年龄段分布</div>
            <Empty v-if="barAgeEmpty" class="empty-container"></Empty>
            <VChart
              v-else
              style="width: 100%; height: 90%"
              :option="barAgeOption"
            ></VChart>
          </div>

          <div class="chart-block">
            <div class="title">孩子年龄占比</div>
            <Empty v-if="barChildAgeEmpty" class="empty-container"></Empty>
            <VChart
              v-else
              style="width: 100%; height: 90%"
              :option="barChildAgeOption"
            ></VChart>
          </div>
        </div>
      </div>

      <div class="tail-container">
        <div class="exp-title">数据说明：</div>
        <div class="exp">
          性别比例：指目标客群男女占比分布，通过大数据模型进行计算推测。主要根据线下生活方式场景进行判定
        </div>
        <div class="exp">
          年龄段分布：指目标客群不同年龄段占比分布，可判断客群是否符合本产品定位。18岁以下人数根据国家对于大数据相关规定不包含在数据中展示。
        </div>
        <div class="exp">
          未成年子女情况：指目标客群有无孩子占比分布（对18岁以下进行统计），通过目标客群到访亲子类场所的次数以及时间且年龄在一定范围内进行判定，可判断客群是否符合本产品定位。
        </div>
        <div class="exp">
          孩子年龄：指目标客群拥有的未成年子女年龄段的占比分布，通过目标客群到访亲子类场所的次数以及时间且年龄在一定范围内进行判定。
        </div>
      </div>
    </div>

    <div v-if="reportCustomization.showDataSource" class="page-bottom-tips">
      数据来源：位置厂商数据结合边界自有模型测算
    </div>
  </div>
</template>
<script setup>
import store from '@/store'
import { ref, onMounted } from 'vue'

import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import Empty from "./components/Empty"

const props = defineProps({
  pageNum: String,
  moduleData: {
    type: Object,
    default: () => {}
  },
  reportCustomization: {
    type: Object,
    default: () => {},
  },
  commonLang: {
    type: String,
    default: 'zh'
  },
  yfhwData: {
    type: Object,
    default: () => {},
  },
});

// 性别比例
const pieGenderOption = ref()
const maleValue = ref('')
const femaleValue = ref('')

// 未成年子女情况
const pieChildOption = ref()
const noChildValue = ref('')
const hasChildValue = ref('')

// 年龄段分布
const barAgeEmpty = ref(false)
const barAgeOption = ref()

// 孩子年龄占比
const barChildAgeEmpty = ref(false)
const barChildAgeOption = ref()

const wrapData = () => {
  const { maleRate, femaleRate, hasChildRate, noChildRate, ageList, childAgeList } = props.yfhwData

  maleValue.value = maleRate
  femaleValue.value = femaleRate
  const genderList = [
    { name: '女性', value: femaleRate },
    { name: '男性', value: maleRate },
  ]
  pieGenderOption.value = {
    title: {
      text: '性别',
      left: 'center',
      top: 'center',
      textStyle: {
        fontSize: 14,
        color: '#000000',
      },
    },
    series: [
      {
        type: 'pie',
        radius: [35, 80],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderWidth: 2,
          borderColor: '#F6F6F6',
          color(colors) {
            let color = [
              '#FFBA00',
              '#65A2FF',
            ]
            return color[colors.dataIndex]
          },
        },
        label: {
          show: true,
          formatter: '{b}\n{d}%',
          color: '#333333',
          fontSize: 18,
          position: 'outer',
          alignTo: 'top',
          margin: 50,
        },
        labelLine: {
          lineStyle: {
            color: '#00000073',
          },
        },
        data: genderList,
      },
    ],
  }

  hasChildValue.value = hasChildRate
  noChildValue.value = noChildRate
  const childList = [
    { name: '无', value: noChildRate },
    { name: '有', value: hasChildRate },
  ]
  pieChildOption.value = {
    title: {
      text: '子女',
      left: 'center',
      top: 'center',
      textStyle: {
        fontSize: 14,
        color: '#000000',
      },
    },
    series: [
      {
        type: 'pie',
        radius: [35, 80],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderWidth: 2,
          borderColor: '#F6F6F6',
          color(colors) {
            let color = [
              '#6F8097',
              '#00DA78',
            ]
            return color[colors.dataIndex]
          },
        },
        label: {
          show: true,
          formatter: '{b}\n{d}%',
          color: '#333333',
          fontSize: 18,
          position: 'outer',
          alignTo: 'top',
          margin: 50,
        },
        labelLine: {
          length: 10,
          lineStyle: {
            color: '#00000073',
          },
        },
        data: childList,
      },
    ],
  }

  barAgeEmpty.value = !ageList.length
  barAgeOption.value = {
    grid: {
      top: 40,
      left: 94,
      bottom: 40,
      right: 40,
    },
    xAxis: {
      type: 'category',
      data: ageList.map((a) => a.key),
      axisLabel: {
        color: '#595959',
        interval: 0,
        fontSize: '14px',
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        formatter: '{value} %',
        fontSize: '14px',
      },
    },
    series: {
      type: 'bar',
      data: ageList.map((a) => a.value),
      barWidth: 42,
      itemStyle: {
        color: '#4B86FF',
      },
      label: {
        show: true,
        formatter(param) {
          return param.value + '%'
        },
        position: 'top',
        color: '#595959',
        fontSize: '18px',
      },
    },
  }

  barChildAgeEmpty.value = !childAgeList.length
  barChildAgeOption.value = {
    grid: {
      top: 40,
      left: 94,
      bottom: 40,
      right: 40,
    },
    xAxis: {
      type: 'category',
      data: childAgeList.map((a) => a.key),
      axisLabel: {
        color: '#595959',
        interval: 0,
        fontSize: '14px',
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        formatter: '{value} %',
        fontSize: '14px',
      },
    },
    series: {
      type: 'bar',
      data: childAgeList.map((a) => a.value),
      barWidth: 42,
      itemStyle: {
        color: '#17C49D',
      },
      label: {
        show: true,
        formatter(param) {
          return param.value + '%'
        },
        position: 'top',
        color: '#595959',
        fontSize: '18px',
      },
    },
  }
}

onMounted(() => {
  wrapData()
})
</script>
<style scoped lang="less">
.yfhw-page16 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;

  .content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 30px 60px 0;
    width: 100%;

    .head-container {
      flex: 1;
      display: flex;
      justify-content: space-around;

      .title {
        margin-top: 20px;
        margin-left: 22px;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.88);
      }

      .left-container {
        width: 39%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .combo-container {
          flex: 1;
          display: flex;
          align-items: center;
          width: 100%;
        }

        .chart-container {
          display: flex;
          flex-direction: column;
          width: 60%;
          height: 100%;
        }

        .info-container {
          width: 40%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;

          .info {
            padding: 14px 24px 14px 98px;
            width: 220px;
            border-radius: 8px;

            background-size: 52px 52px;
            background-position: center left 24px;
            background-repeat: no-repeat;

            &.male {
              background-color: #65A2FF;
              background-image: url('~@/assets/report-v2/yfhw/ic-male.svg');
            }

            &.female {
              margin-top: 10px;
              background-color: #FFBA00;
              background-image: url('~@/assets/report-v2/yfhw/ic-female.svg');
            }

            &.child {
              background-color: #00DA78;
              background-size: 48px 42px;
              background-image: url('~@/assets/report-v2/yfhw/ic-have-child.webp');
            }

            &.no-child {
              margin-top: 10px;
              background-color: #6F8097;
              background-size: 48px 42px;
              background-image: url('~@/assets/report-v2/yfhw/ic-no-child.webp');
            }
          }

          .sign {
            line-height: 22px;
            font-size: 16px;
          }

          .percentage {
            margin-top: 5px;
            line-height: 34px;
            font-size: 24px;
            font-weight: 500;
          }
        }
      }

      .right-container {
        display: flex;
        flex-direction: column;
        width: 59%;
        height: 100%;

        .chart-block {
          flex: 1;
          width: 100%;
        }
      }
    }

    .tail-container {
      flex-shrink: 0;
      margin-top: 18px;
      padding: 10px 24px 20px;
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 16px;

      .exp-title {
        font-size: 24px;
        color: #333333;
        margin-top: 16px;
        margin-left: 20px;
      }

      .exp {
        font-size: 18px;
        margin-top: 10px;
        margin-left: 20px;
        color: #333333;
      }

      .exp::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        vertical-align: middle;
        background-color: #2c75f2;
      }
    }
  }

  .empty-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
